<template>
<div>
    <ValidationObserver class="w-100" ref="observer">
      <b-row>
        <b-col md="6">
          <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
            <input type="date" class="form-control mt-2" v-model="form.call_date">
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
            <b-form-input
                id="time"
                value="00:00"
                type="time"
                class="mt-2"
                v-model="form.call_time"
            ></b-form-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
    </ValidationObserver>
    <div class="d-flex justify-content-end mt-4">
      <b-button variant="primary" @click="sendSubmit">{{$t('message.Submit')}}</b-button>
    </div>
</div>
</template>

<script>
import { ValidationProvider,ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/ru.json';
import {callUserToTest} from '../../../../../../../api/school-vacany-applications'

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule]
  });
});

export default {
  name: "Form",
  components:{
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    testStatus: {
      type: Object,
      required: true,
    },
    app: {
      required: true,
      default: null,
    }
  },
  data() {
    return {
      form: {
        call_date: null,
        call_time: "00:00",
        description: "",
        school_id: null,
        school_name: '',
        vacancy_id: null,
      }
    }
  },
  methods: {
    async sendSubmit() {
      const isValid = await this.$refs.observer.validate()
      if(isValid) {
        this.form.school_id = this.app.school_id;
        this.form.school_name = this.app.school.organizationshortname;
        this.form.vacancy_id = this.app.id;
        callUserToTest({...this.form,...this.testStatus}).then(res => {
          this.$emit('closeForm', {id: this.testStatus.application_id, data: res.data.data})
        })
      }
    }
  }
}
</script>

<style scoped>
.button{
  margin-top: 20px;
  margin-left: 340px;
}
</style>
